import { apiSlice } from '../apiSlice';
import { SuccessResponse } from '../DTO/common.interface';
import {
	RecoveryAssessmentScaleDTO,
	RecoveryAssessmentScaleRequest,
	RecoveryAssessmentScaleSaveDTO,
} from '../DTO/forms-management/recoveryAssessmentScale';

export const recoveryAssessmentScale = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getRecoveryAssessmentScaleList: builder.query<
			SuccessResponse<RecoveryAssessmentScaleDTO[]>,
			string
		>({
			query: (id) => ({
				url: `/web/form/recovery-assessment-scale/list/${id}`,
				method: 'GET',
			}),
			providesTags: ['RecoveryAssessmentScaleList'],
		}),
		deleteRecoveryAssessmentScale: builder.mutation<
			SuccessResponse<any>,
			string
		>({
			query: (id) => ({
				url: `/web/form/recovery-assessment-scale/${id}`,
				method: 'DELETE',
			}),

			invalidatesTags: ['RecoveryAssessmentScaleList'],
		}),
		RecoveryAssessmentScaleHasDraft: builder.query<
			SuccessResponse<any>,
			string
		>({
			query: (id) => ({
				url: `/web/form/recovery-assessment-scale/has-draft/${id}`,
				method: 'GET',
			}),
			keepUnusedDataFor: 0,
		}),
		getRecoveryAssessmentScaleDraft: builder.query<
			SuccessResponse<RecoveryAssessmentScaleSaveDTO>,
			{ id: string; type: string }
		>({
			query: ({ id, type }) => ({
				url: `/web/form/recovery-assessment-scale/to-create/${id}/${type}`,
				method: 'GET',
			}),
		}),
		continueRecoveryAssessmentScaleDraft: builder.mutation<
			SuccessResponse<RecoveryAssessmentScaleSaveDTO>,
			{ id: string; type: number }
		>({
			query: ({ id, type }) => ({
				url: `/web/form/recovery-assessment-scale/to-create/${id}/${type}`,
				method: 'GET',
			}),
		}),
		editRecoveryAssessmentScale: builder.mutation<
			SuccessResponse<any>,
			RecoveryAssessmentScaleRequest
		>({
			query: (body) => ({
				url: `/web/form/recovery-assessment-scale/${body.id}`,
				method: 'PUT',
				body,
			}),
		}),
		createRecoveryAssessmentScale: builder.mutation<
			SuccessResponse<any>,
			RecoveryAssessmentScaleRequest
		>({
			query: (body) => ({
				url: `/web/form/recovery-assessment-scale`,
				method: 'POST',
				body,
			}),
		}),
		getRecoveryAssessmentScaleDetail: builder.query<
			SuccessResponse<RecoveryAssessmentScaleDTO>,
			string
		>({
			query: (id) => ({
				url: `/web/form/recovery-assessment-scale/${id}`,
				method: 'GET',
			}),
		}),
	}),
});

export const {
	useGetRecoveryAssessmentScaleListQuery,
	useDeleteRecoveryAssessmentScaleMutation,
	useRecoveryAssessmentScaleHasDraftQuery,
	useGetRecoveryAssessmentScaleDraftQuery,
	useContinueRecoveryAssessmentScaleDraftMutation,
	useEditRecoveryAssessmentScaleMutation,
	useCreateRecoveryAssessmentScaleMutation,
	useGetRecoveryAssessmentScaleDetailQuery,
} = recoveryAssessmentScale;
